// document ready
jQuery(document).ready(function ($) {

    // nav click toggle menu open
    $('#btn-header-nav').on('click', function () {
        $('BODY')[$('BODY').hasClass('header-nav-open') ? 'removeClass' : 'addClass']('header-nav-open');
    });

    // nav click toggle menu open
    $('#btn-product-sidebar').on('click', function () {
        $('BODY')[$('BODY').hasClass('product-sidebar-open') ? 'removeClass' : 'addClass']('product-sidebar-open');
    });

    // nav click toggle menu open
    $('#btn-mobile-search, #btn-header-search').on('click', function () {
        $('BODY')[$('BODY').hasClass('product-search-open') ? 'removeClass' : 'addClass']('product-search-open');
    });

    // panel list show children
    $('.show-children','.panel-list').on('click', function (e) {
        e.preventDefault();
        $(this).parent()[$(this).parent().hasClass('active') ? 'removeClass' : 'addClass']('active');
    });

    // images loaded
    $('MAIN').imagesLoaded()
        .always(function (instance) {
            //console.log('all images loaded');
        })
        .done(function (instance) {
            //console.log('all images successfully loaded');
        })
        .progress( function(instance,image) {
            $(image.img).addClass('img-loaded');
            // console.log( 'image is ' + result + ' for ' + image.img.src );
        });


    // enable tooltips for everything
    tooltips = function() {

        // tool tip config
        $('[data-toggle="tooltip"]').tooltip({
            boundary: 'scrollParent',
            placement: 'top'
        });

    }; tooltips();


    // enable dismiss alerts
    $('.alert').alert();


    // enable tooltips for everything
    let banner_size = function() {

        // var heights
        var windowHeight = $(window).outerHeight();
        var headerHeight = $('BODY > HEADER').outerHeight();

        // banner height
        $('.banner').height(windowHeight-headerHeight);

    };


    // image slide var
    let $imgSlider = $('.img-slider');

    // slick image slider
    $imgSlider.slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
        cssEase: 'linear',
        prevArrow: '<button type="button" class="slick-prev"><i class="far fa-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="far fa-chevron-right"></i></button>',
        mobileFirst: true
    });

    // image slide light gallery
    $imgSlider.lightGallery({
        selector: '.slick-slide:not(.slick-cloned) .lightgallery',
    });

    // image slide var
    let $imgGrid = $('.img-grid');

    // image slide light gallery
    $imgGrid.lightGallery({
        selector: '.lightgallery',
    });

    // image slide var
    let $imgSolo = $('.img-solo');

    // image slide light gallery
    $imgSolo.lightGallery({
        selector: '.lightgallery',
    });

    // window resize
    $(window).on('resize', function () {

        // resize pixel stuff
        banner_size();

    }).trigger('resize');

});